export default {"src":"/_next/static/media/Star.a5a398b1.svg","height":16,"width":16};